import { formatInteger } from "../../../i18n/format";
import { useInterfaceLocale } from "./useInterfaceLocale";

/** ElevenLabs credits (characters) with grouping; a fractional credit is rounded before it is shown. */
export function Credits({ value }: { value: number | null | undefined }) {
  const locale = useInterfaceLocale();
  return (
    <span data-component="Credits" className="tabular-nums">
      {formatInteger(typeof value === "number" ? Math.round(value) : value, locale)}
    </span>
  );
}
